/*
 * @Desc: 会员相关请求api
 * @Author: jiayi zhu
 * @Date: 2019-10-17 09:16:49
 * @LastEditors: jiayi zhu
 */
export default {
  getEasyMemberIntroduce(data) {
    return this.http('Lottery', 'get', '/api/v2/easy_config', data);
  },
  getMemberMes(data) {
    return this.http(
      'Columbus',
      'get',
      '/api/v1/members/users/detail',
      data
    );
  },
  createMemberOrder(data) {
    return this.http('Columbus', 'post', '/api/v2/orders', data);
  },
  checkMemberStatus() {
    return this.http('Passport', 'get', '/api/v1/vip_member');
  },
  getMemberExculateStatus() {
    return this.http('Columbus', 'get', '/api/v1/wisdom/contracts/status');
  },
  // 获取用户NPS问卷状态
  getNpsStatus(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/v1/nps/user_surveys/detail',
      params
    );
  },
  // 关闭问卷
  postNpsClose(params) {
    return this.http(
      'Columbus',
      'post',
      '/api/v1/nps/user_surveys/reject',
      params
    );
  },
  // 获取会员权益
  getEquitys(params) {
    return this.http('Lottery', 'post', '/api/lite/members', params);
  },
  // 获取会员零食权益领取状态
  getSnackStatus(type) {
    return this.http(
      'Lottery',
      'GET',
      `/api/v1/benefit_protos/latest?type=${type}`
    );
  },
  // 获取会员零食列表
  getSnackList() {
    return this.http(
      'Lottery',
      'GET',
      '/api/v1/benefit_protos/goods_list'
    );
  },
  // 获取会员零食权益
  getSnack(data) {
    return this.http(
      'Lottery',
      'POST',
      '/api/v1/benefit_protos/receive',
      data
    );
  },
  // 发送手机验证码
  postVertifyCode(data) {
    return this.http(
      'Passport',
      'post',
      '/api/v1/users/send_cellphone_verification',
      data
    );
  },
  // 验证手机验证码
  verifyCode(data) {
    return this.http(
      'Passport',
      'post',
      '/api/v1/users/verify_cellphone',
      data
    );
  },
  // 激活会员
  activeMember(data) {
    return this.http('Lottery', 'post', '/api/lite/members/active', data);
  },
  getMemberStatus() {
    return this.http('Lottery', 'get', '/api/v1/users/vip_status');
  },
  getFreeScale(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/coupons/receive_scale',
      data
    );
  },
  getEqulitySettings(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/member_benefit_lists',
      data
    );
  },
  getEqulityGiftList(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/member_present_coupon_protos',
      data
    );
  },
  chooseEqulityGift(data) {
    return this.http(
      'Lottery',
      'post',
      '/api/v1/send_coupon_records',
      data
    );
  },
  getEqulityGiftMes(id) {
    return this.http(
      'Lottery',
      'get',
      `/api/v1/send_coupon_records/${id}`
    );
  }
};
